import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { Text } from 'bold-ui'
import { Fragment } from 'react'

import { getOutroOuPergunta, getOutroOuResposta } from '../utils-HistoricoMchatRf'
import { HistoricoMChatSimpleVerticalTableItem } from './HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMChatTwoColumnTableItem } from './HistoricoMchatTwoColumnTableItem'

interface HistoricoMchatExemplosPassouFalhouTableItemProps {
  exemplosPassou: ReadonlyArray<MchatRfAplicacaoQueryModel> | undefined
  exemplosFalhou: ReadonlyArray<MchatRfAplicacaoQueryModel> | undefined
}

export const HistoricoMchatExemplosPassouFalhouTableItem = (
  props: Readonly<HistoricoMchatExemplosPassouFalhouTableItemProps>
) => {
  const { exemplosPassou, exemplosFalhou } = props
  const hasExemplosPassou = exemplosPassou !== undefined && exemplosPassou.length > 0
  const hasExemplosFalhou = exemplosFalhou !== undefined && exemplosFalhou.length > 0

  const passou = hasExemplosPassou && (
    <Fragment>
      <Text fontWeight='bold'>Exemplos Passou:</Text>
      {exemplosPassou.map((aplicacao) => (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta={getOutroOuPergunta(aplicacao)}
          resposta={getOutroOuResposta(aplicacao)}
          key={aplicacao.pergunta}
        />
      ))}
    </Fragment>
  )

  const falhou = hasExemplosFalhou && (
    <Fragment>
      <Text fontWeight='bold'>Exemplos Falhou:</Text>
      {exemplosFalhou.map((aplicacao) => (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta={getOutroOuPergunta(aplicacao)}
          resposta={getOutroOuResposta(aplicacao)}
          key={aplicacao.pergunta}
        />
      ))}
    </Fragment>
  )

  return (
    <HistoricoMChatTwoColumnTableItem
      left={hasExemplosPassou ? passou : falhou}
      right={hasExemplosPassou ? falhou : null}
    />
  )
}
